 
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useThemeColors } from '../hooks/useThemeColors';

function Cloud({ color, size = 1, top, left, right, bottom }: { color: string; size?: number | undefined; top?: number | undefined; left?: number | undefined; right?: number | undefined; bottom?: number | undefined}) {
  const s = size;
  return (
    <View style={[styles.wrap, { top, left, right, bottom, width: 70 * s, height: 35 * s }]} pointerEvents="none">
      <View style={[styles.puff, { width: 24 * s, height: 24 * s, borderRadius: 12 * s, backgroundColor: color, left: 0, top: 8 * s }]} />
      <View style={[styles.puff, { width: 32 * s, height: 32 * s, borderRadius: 16 * s, backgroundColor: color, left: 14 * s, top: 2 * s }]} />
      <View style={[styles.puff, { width: 26 * s, height: 26 * s, borderRadius: 13 * s, backgroundColor: color, left: 38 * s, top: 6 * s }]} />
      <View style={[styles.puff, { width: 18 * s, height: 18 * s, borderRadius: 9 * s, backgroundColor: color, left: 52 * s, top: 12 * s }]} />
    </View>
  );
}

const HUE_RAMP_LIGHT = ['#B8E0F0', '#C5E8C5', '#F5D5C8', '#E8EFF5', '#F0E8F5'] as const;
const HUE_RAMP_DARK = ['#3A6378', '#3F6A4E', '#7A4E42', '#4A5566', '#5A4A60'] as const;

export function CloudDecoration() {
  const theme = useThemeColors();
  // Dark mode dims via cloudFill; light mode keeps the multi-hue ramp
  // so the existing design (visible on the landing page) is preserved.
  const isDark = theme.backgroundPage !== '#F9F9F7';
  const ramp = isDark ? HUE_RAMP_DARK : HUE_RAMP_LIGHT;
  return (
    <>
      <Cloud color={ramp[0]} size={2} top={10} left={-40} />
      <Cloud color={ramp[1]} size={1.7} top={50} right={-30} />
      <Cloud color={ramp[2]} size={1.8} bottom={80} left={0} />
      <Cloud color={ramp[3]} size={1.4} top={140} right={20} />
      <Cloud color={ramp[4]} size={1.2} top={200} left={30} />
      <Cloud color={ramp[0]} size={1.1} bottom={130} right={40} />
      <Cloud color={ramp[1]} size={1} bottom={20} left={-20} />
    </>
  );
}

// StyleSheet: SVG components require style objects
const styles = StyleSheet.create({
  wrap: { position: 'absolute', overflow: 'visible', opacity: 0.65 },
  puff: { position: 'absolute' },
});
